// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Website Users — compact table layout */

.wu-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 100px);
  min-height: 480px;
  max-height: calc(100vh - 88px);
}

.wu-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.wu-search {
  flex: 1 1;
  min-width: 180px;
  max-width: 320px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
}

.wu-toolbar-note {
  font-size: 15px;
  color: #94a3b8;
}

.wu-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.wu-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.wu-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.wu-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.wu-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.wu-btn--primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.wu-btn--live {
  background: #ecfdf5;
  border-color: #bbf7d0;
  color: #047857;
}

.wu-btn--danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.wu-bulk {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  color: #475569;
  flex-shrink: 0;
}

.wu-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  flex-shrink: 0;
}

.wu-toast button {
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.wu-toast--ok {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #bbf7d0;
}

.wu-toast--err {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.wu-table-panel {
  flex: 1 1;
  min-height: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wu-table-scroll {
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.wu-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 15px;
}

.wu-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fafbfc;
  padding: 9px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #e2e8f0;
}

.wu-table thead th:first-child { width: 36px; }
.wu-table thead th:last-child { width: 120px; }

.wu-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
}

.wu-table tbody tr:hover {
  background: #f8fafc;
}

.wu-table tbody tr.wu-row--selected {
  background: #eff6ff;
}

.wu-org-name {
  display: block;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wu-user-line {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wu-badge {
  font-size: 14px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.wu-badge--free { background: #f1f5f9; color: #475569; }
.wu-badge--trial { background: #fef9c3; color: #854d0e; }
.wu-badge--active { background: #dcfce7; color: #166534; }
.wu-badge--expired,
.wu-badge--cancelled,
.wu-badge--revoked { background: #fee2e2; color: #991b1b; }

.wu-fp {
  font-size: 13px;
  color: #64748b;
  text-transform: capitalize;
}

.wu-fp--linked { color: #059669; font-weight: 600; }

.wu-date {
  font-size: 15px;
  color: #64748b;
  white-space: nowrap;
}

.wu-actions {
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}

.wu-icon-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.wu-table tbody tr:hover .wu-icon-btn {
  color: #94a3b8;
}

.wu-icon-btn:hover:not(:disabled) {
  background: #f1f5f9;
  color: #475569;
}

.wu-icon-btn--danger:hover:not(:disabled) {
  background: #fef2f2;
  color: #dc2626;
}

.wu-check {
  border: none;
  background: none;
  cursor: pointer;
  color: #94a3b8;
  padding: 0;
  display: flex;
}

.wu-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-top: 1px solid #f1f5f9;
  flex-shrink: 0;
  font-size: 15px;
  color: #64748b;
}

.wu-pagination-btns {
  display: flex;
  gap: 6px;
}

.wu-empty,
.wu-loading {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #94a3b8;
  font-size: 15px;
  padding: 24px;
}

.wu-spin {
  animation: wu-spin 0.8s linear infinite;
}

@keyframes wu-spin {
  to { transform: rotate(360deg); }
}

/* Modals */
.wu-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  padding: 16px;
}

.wu-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 520px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.wu-modal--sm {
  max-width: 400px;
}

.wu-modal--lg {
  max-width: 640px;
}

.wu-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.wu-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.wu-modal-close {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wu-modal-body {
  padding: 16px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.wu-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
}

.wu-field {
  margin-bottom: 12px;
}

.wu-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
}

.wu-field input,
.wu-field select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  box-sizing: border-box;
}

.wu-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.wu-form-row .wu-field {
  margin-bottom: 0;
}

.wu-toggle-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #475569;
}

.wu-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.wu-detail-section h4 {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 10px;
}

.wu-detail-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 15px;
  padding: 6px 0;
  border-bottom: 1px solid #f8fafc;
}

.wu-detail-row span:first-child {
  color: #94a3b8;
}

.wu-detail-row span:last-child {
  color: #334155;
  font-weight: 500;
  text-align: right;
}

.wu-detail-empty {
  padding: 20px;
  text-align: center;
  background: #f8fafc;
  border-radius: 8px;
  color: #94a3b8;
  font-size: 15px;
}

.wu-confirm-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fef2f2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.wu-confirm-text {
  text-align: center;
  font-size: 15px;
  color: #64748b;
  margin-bottom: 16px;
}

@media (max-width: 768px) {
  .wu-page {
    height: auto;
    max-height: none;
  }

  .wu-table-scroll {
    max-height: 480px;
  }

  .wu-form-row,
  .wu-detail-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/website/InukaUsersManager.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,iCAAiC,WAAW,EAAE;AAC9C,gCAAgC,YAAY,EAAE;;AAE9C;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD;;qBAEqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;;AAEnD;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Website Users — compact table layout */\n\n.wu-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: calc(100vh - 100px);\n  min-height: 480px;\n  max-height: calc(100vh - 88px);\n}\n\n.wu-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.wu-search {\n  flex: 1;\n  min-width: 180px;\n  max-width: 320px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n}\n\n.wu-toolbar-note {\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.wu-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.wu-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.wu-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.wu-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.wu-btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.wu-btn--primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.wu-btn--live {\n  background: #ecfdf5;\n  border-color: #bbf7d0;\n  color: #047857;\n}\n\n.wu-btn--danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.wu-bulk {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #475569;\n  flex-shrink: 0;\n}\n\n.wu-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.wu-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.wu-toast--ok {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #bbf7d0;\n}\n\n.wu-toast--err {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.wu-table-panel {\n  flex: 1;\n  min-height: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.wu-table-scroll {\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.wu-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 15px;\n}\n\n.wu-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fafbfc;\n  padding: 9px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.wu-table thead th:first-child { width: 36px; }\n.wu-table thead th:last-child { width: 120px; }\n\n.wu-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: middle;\n}\n\n.wu-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.wu-table tbody tr.wu-row--selected {\n  background: #eff6ff;\n}\n\n.wu-org-name {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.wu-user-line {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.wu-badge {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.wu-badge--free { background: #f1f5f9; color: #475569; }\n.wu-badge--trial { background: #fef9c3; color: #854d0e; }\n.wu-badge--active { background: #dcfce7; color: #166534; }\n.wu-badge--expired,\n.wu-badge--cancelled,\n.wu-badge--revoked { background: #fee2e2; color: #991b1b; }\n\n.wu-fp {\n  font-size: 13px;\n  color: #64748b;\n  text-transform: capitalize;\n}\n\n.wu-fp--linked { color: #059669; font-weight: 600; }\n\n.wu-date {\n  font-size: 15px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.wu-actions {\n  display: flex;\n  gap: 4px;\n  justify-content: flex-end;\n}\n\n.wu-icon-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #cbd5e1;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wu-table tbody tr:hover .wu-icon-btn {\n  color: #94a3b8;\n}\n\n.wu-icon-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.wu-icon-btn--danger:hover:not(:disabled) {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.wu-check {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #94a3b8;\n  padding: 0;\n  display: flex;\n}\n\n.wu-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-top: 1px solid #f1f5f9;\n  flex-shrink: 0;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.wu-pagination-btns {\n  display: flex;\n  gap: 6px;\n}\n\n.wu-empty,\n.wu-loading {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 15px;\n  padding: 24px;\n}\n\n.wu-spin {\n  animation: wu-spin 0.8s linear infinite;\n}\n\n@keyframes wu-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Modals */\n.wu-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  padding: 16px;\n}\n\n.wu-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 520px;\n  max-height: calc(100vh - 32px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);\n}\n\n.wu-modal--sm {\n  max-width: 400px;\n}\n\n.wu-modal--lg {\n  max-width: 640px;\n}\n\n.wu-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.wu-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.wu-modal-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wu-modal-body {\n  padding: 16px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.wu-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.wu-field {\n  margin-bottom: 12px;\n}\n\n.wu-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 5px;\n}\n\n.wu-field input,\n.wu-field select {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  box-sizing: border-box;\n}\n\n.wu-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.wu-form-row .wu-field {\n  margin-bottom: 0;\n}\n\n.wu-toggle-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  color: #475569;\n}\n\n.wu-detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.wu-detail-section h4 {\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin: 0 0 10px;\n}\n\n.wu-detail-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 15px;\n  padding: 6px 0;\n  border-bottom: 1px solid #f8fafc;\n}\n\n.wu-detail-row span:first-child {\n  color: #94a3b8;\n}\n\n.wu-detail-row span:last-child {\n  color: #334155;\n  font-weight: 500;\n  text-align: right;\n}\n\n.wu-detail-empty {\n  padding: 20px;\n  text-align: center;\n  background: #f8fafc;\n  border-radius: 8px;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.wu-confirm-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #fef2f2;\n  color: #dc2626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 12px;\n}\n\n.wu-confirm-text {\n  text-align: center;\n  font-size: 15px;\n  color: #64748b;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 768px) {\n  .wu-page {\n    height: auto;\n    max-height: none;\n  }\n\n  .wu-table-scroll {\n    max-height: 480px;\n  }\n\n  .wu-form-row,\n  .wu-detail-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
